import React, { useContext, useEffect, useState } from 'react';
import './Admin.scss';
import MyContext from '../Uttis/MyContext';
import { FcApproval } from "react-icons/fc";
import { RxCross2 } from "react-icons/rx";
import axios from 'axios';


const Admin = () => {
  const { setShowCompletionForm,fetchStudents,setShowOfferForm, students,url,setMessage,setSnack,setLoading,setShowCustomForm,setSavenameid} = useContext(MyContext);
  const [selectedStudent, setSelectedStudent] = useState(null);
  
const [searchTerm, setSearchTerm] = useState('');

const filteredStudents = students.filter((student) => {
const search = searchTerm.toLowerCase();
return (
student.name?.toLowerCase().includes(search) ||
student.techopted?.toLowerCase().includes(search) ||
student.institutename?.toLowerCase().includes(search)
);
});

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleCloseModal = () => {
    setSelectedStudent(null);
  };

  const handleApprove = async(id) => {
    setLoading(true);
document.querySelector("body").style.overflow = "hidden";
 try {
      const { data } = await axios.post(`${url}/student-approve`, { id }); 
      if (data.success) {
        setSnack(true);
        setMessage(data.message);
        fetchStudents(); 
        setSelectedStudent(null);
      } else {
        setSnack(true);
        setMessage(data.message);
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Something went wrong while aproving');
    }
     finally {
setLoading(false);
document.querySelector("body").style.overflow = "auto";
}
};

const handleDelete = async (id) => {
  if (window.confirm('Are you sure you want to delete this student?')) {
    try {
      const { data } = await axios.post(`${url}/student-delete`, { id }); 
      if (data.success) {
        setSnack(true);
        setMessage(data.message);
        setSelectedStudent(null);
        fetchStudents(); 
      } else {
        alert('Failed to delete student');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Something went wrong while deleting');
    }
  }
};


const handleOfferLetter = async (id,name,techopted) => {
  setSavenameid({ id, name,techopted });
  setShowOfferForm(true);
  

}

const handleCompletionLetter = async (id,name) => {
  setSavenameid({ id, name });
  setShowCompletionForm(true);

}



const handleSendOther = (id,name) => {
   setSavenameid({ id, name });
  setShowCustomForm(true);
  
}






  return (
    <div className="admin-container">
      <h2>Students</h2>
       <h4>Total Students: {filteredStudents.length}</h4>

       <input
type="text"
placeholder="Search by name..."
value={searchTerm}
onChange={(e) => setSearchTerm(e.target.value)}
className="search-input"
/>
      <div className="card-grid">
        {filteredStudents.map((student) => (
          <div className="student-card" key={student._id}>
            <img src={student.photo} alt={student.name} className="student-photo" />
            <h3>{student.name}</h3>
             {student.approved &&
    <span className="vertical-badge">A<br/>p<br/>p<br/>r<br/>o<br/>v<br/>e<br/>d</span>

             }
 
            <button onClick={() => setSelectedStudent(student)}>Show More</button>
          </div>
        ))}
      </div>

      {selectedStudent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>

        
  <div className="send-wrapper">
    <button className="send-btn">Send</button>

    <div className="letter-actions">
      <button className="letter-btn" onClick={() => handleOfferLetter(selectedStudent._id,selectedStudent.name,selectedStudent.techopted)}>
        Generate Offer Letter
      </button>
      
      <button className="letter-btn" onClick={() => handleCompletionLetter(selectedStudent._id,selectedStudent.name)}>
        Completion Certificate
      </button>
      <button className="letter-btn secondary" onClick={() => handleSendOther(selectedStudent._id, selectedStudent.name)}>
        Send Other Email
      </button>
    </div>
  </div>



              <button className="close-btn" onClick={handleCloseModal}>X</button>
            <img src={selectedStudent.photo} alt={selectedStudent.name} className="modal-photo" />
            <h2>{selectedStudent.name}</h2>
            <p><strong>Email:</strong> {selectedStudent.email}</p>
            <p><strong>Mobile:</strong> {selectedStudent.mobile}</p>
            <p><strong>Date of Birth:</strong> {new Date(selectedStudent.dob).toLocaleDateString('en-GB')}</p>
            <p><strong>Tech Opted:</strong> {selectedStudent.techopted}</p>
            <p><strong>Institute:</strong> {selectedStudent.institutename}</p>
            <p><strong>Education:</strong> {selectedStudent.education}</p>
            <p><strong>Status:</strong> {selectedStudent.currentstatus}</p>
            <p><strong>Duration:</strong> {selectedStudent.duration}</p>
            <p><strong>Fees:</strong> ₹{selectedStudent.fees}</p>
            <p><strong>Permanent Address:</strong> {selectedStudent.permanentadd}</p>
            <p><strong>Present Address:</strong> {selectedStudent.presentadd}</p>
            <p><strong>Pincode:</strong> {selectedStudent.pincode}</p>
            <p><strong>Referred By:</strong> {selectedStudent.referedby}</p>
            {selectedStudent.startdate && <p><strong>Start Date:</strong> {new Date(selectedStudent.startdate).toLocaleDateString("en-IN") }</p>}
            {selectedStudent.enddate && <p><strong>End Date:</strong> {new Date(selectedStudent.enddate).toLocaleDateString("en-IN") }</p>}
            <p><strong>Aadhar:</strong> <a href={selectedStudent.aadhar} target="_blank" rel="noreferrer">View Aadhar</a></p>

            <div className="modal-actions">
 <button className="approve-btn" onClick={() => handleApprove(selectedStudent._id)}>
  {selectedStudent.approved?'Approved':'Approve'} <FcApproval />
</button>
  <button className="delete-btn" onClick={() => handleDelete(selectedStudent._id)}>Delete <RxCross2 /></button>
</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
